import Grid from '@jobcost-monorepo/crud/ui/Grid';
import {
  IResourceFetchParams,
  IResource,
  MN_RESOURCES,
} from '@jobcost-monorepo/crud';

export default function ResourcesPage() {
  return (
    <Grid<IResource, IResourceFetchParams>
      moduleName={MN_RESOURCES}
      updateStore={false}
    ></Grid>
  );
}
